export default __webpack_public_path__ + "static/media/Festrahmenfenster SL.e111d7c1.jpg";